import { OrderRefusalModule } from './refusal/order-refusal.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list/list.component';
import { UpdateComponent } from './update/update.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTableModule } from '@angular/material/table';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { ProductModule } from '../product/product.module';
import { WarehouseModule } from '../warehouse/warehouse.module';
import { OrderStagingModule } from '../order-staging/order-staging.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ClientModule } from '../client/client.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { SelectorModule } from '../selector/selector.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProviderModule } from '../provider/provider.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LiqpaySumComponent } from './liqpay-sum/liqpay-sum.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OrderListModule } from './list/order-list.module';
import { PaymentLinkDialogModule } from '../docs/client-invoice/payment-link-dialog/payment-link-dialog.module';
import { TerminalPaymentModule } from '../terminal-payment/terminal-payment.module';
import { UnavailableProductsDialogComponent } from './unavailable-products-dialog/unavailable-products-dialog.component';
import { ContractWithProviderSelectorModule } from '../docs/contract-with-provider/selector/selector.module';
import { NgxMaskModule } from 'ngx-mask';
import { SupplierCancellationDialogComponent } from './supplier-cancellation/supplier-cancellation-dialog.component';
import { TransferCancellationDialogComponent } from './transfer-cancellation/transfer-cancellation-dialog.component';

const routes: Routes = [
  {
    path: '',
    component: ListComponent,
    children: [{ path: 'list', component: ListComponent }]
  },
  { path: 'update/:id', component: UpdateComponent },
  { path: 'create', component: UpdateComponent },
  { path: 'create/by_cart', component: UpdateComponent, data: { byCart: true } }
];

@NgModule({
  declarations: [
    UpdateComponent,
    LiqpaySumComponent,
    UnavailableProductsDialogComponent,
    SupplierCancellationDialogComponent,
    TransferCancellationDialogComponent
  ],
  imports: [OrderRefusalModule,
    RouterModule.forChild(routes),
    OrderListModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    ClipboardModule,
    DragDropModule,
    MatSelectModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatInputModule,
    MatButtonToggleModule,
    MatTableModule,
    MomentDateModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatDialogModule,
    MatMenuModule,
    MatSidenavModule,
    ProductModule,
    WarehouseModule,
    OrderStagingModule,
    SelectorModule,
    MatSnackBarModule,
    ClientModule,
    ProviderModule,
    ContractWithProviderSelectorModule,
    NgxMaskModule,
    PaymentLinkDialogModule,
    TerminalPaymentModule
  ]
})
export class OrderModule {}
